import { useMemo } from "react";
import { LoanProductType } from "./api/types";
import { LoanApplication } from "../contexts";
import { useLoanProductConfigFlags } from "./useLoanProductConfigFlags";

/**
 * Determines if a loan is a credit facility type (Invoice Discounting or Payable Financing)
 * and should display credit facility specific features based on configuration
 */
export const useLoanApplicationCreditFacilityEnabled = (
  loan: LoanApplication | undefined
) => {
  const { showLOCProductsPaymentSchedule } = useLoanProductConfigFlags(
    loan?.loanType as LoanProductType
  );

  return useMemo(() => {
    return (
      showLOCProductsPaymentSchedule &&
      loan &&
      (loan.loanType === LoanProductType.LOC_INVOICE_DISCOUNTING ||
        loan.loanType === LoanProductType.LOC_PAYABLE_FINANCING)
    );
  }, [loan, showLOCProductsPaymentSchedule]);
};
